import { computed, ref } from "@vue/composition-api";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";

export default function useVaultView() {
  const { authorities } = useAuthUser();
  const showPublicVault = ref(false);
  const showPrivateVault = ref(false);
  const isVaultAvailable = computed<boolean>(() => checkAuthorities(authorities.value, ["getMyVault"]));

  const showVaultOrNative = (showNativeFileUploader?: () => void, publicAccess: boolean = false): void => {
    if (isVaultAvailable.value) {
      publicAccess ? (showPublicVault.value = true) : (showPrivateVault.value = true);
    } else {
      showNativeFileUploader && showNativeFileUploader();
    }
  };

  return { showPublicVault, showPrivateVault, isVaultAvailable, showVaultOrNative };
}
